<div class="ng-select custom search-dropdown" [ngClass]="{ 'ng-select-opened': isOpen }">
  <div class="ng-select-container">
    <div class="value-container">
      <div class="ng-input" [ngClass]="{ 'pr-0': !loading }">
        <ng-content></ng-content>
      </div>
    </div>
    <ng-container *ngIf="loading">
      <span class="ng-spinner-loader"></span>
    </ng-container>
  </div>
  <div *ngIf="isOpen" class="ng-dropdown-panel ng-select-bottom" [style.opacity]="(isOpen && items && items.length && '1') || '0'">
    <div class="ng-dropdown-panel-items scroll-host">
      <ng-container *ngFor="let item of items; let i = index">
        <div class="ng-option" (click)="changeItem(i, $event); isOpen = !isOpen">
          <span class="ng-option-label">
            {{ item.name }}
            {{ (item?.identifierQualifier && "IDENTIFIER_QUALIFIER." + item?.identifierQualifier) || "" | translate }}
            {{ item?.address?.city }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>
